var Acoes_CorretivasActions;
(function (Acoes_CorretivasActions) {
    Acoes_CorretivasActions["DELETE_ACOES_CORRETIVAS"] = "DeleteAcoes_Corretivas";
    Acoes_CorretivasActions["DELETE_RANGE_ACOES_CORRETIVAS"] = "DeleteRangeAcoes_Corretivas";
    Acoes_CorretivasActions["FILTER_ACOES_CORRETIVAS"] = "FilterAcoes_Corretivas";
    Acoes_CorretivasActions["GET_ACOES_CORRETIVAS"] = "GetAcoes_Corretivas";
    Acoes_CorretivasActions["GETWITHDISABLED_ACOES_CORRETIVAS"] = "GetWithDisabledAcoes_Corretivas";
    Acoes_CorretivasActions["GET_BY_ID_ACOES_CORRETIVAS"] = "GetByIdAcoes_Corretivas";
    Acoes_CorretivasActions["POST_ACOES_CORRETIVAS"] = "PostAcoes_Corretivas";
    Acoes_CorretivasActions["PUT_ACOES_CORRETIVAS"] = "PutAcoes_Corretivas";
    Acoes_CorretivasActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaAcoes_Corretivas";
    Acoes_CorretivasActions["UPLOAD_PLANILHA"] = "UploadPlanilhaAcoes_Corretivas";
})(Acoes_CorretivasActions || (Acoes_CorretivasActions = {}));
var Acoes_Corretivas_StatusActions;
(function (Acoes_Corretivas_StatusActions) {
    Acoes_Corretivas_StatusActions["DELETE_ACOES_CORRETIVAS_STATUS"] = "DeleteAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["DELETE_RANGE_ACOES_CORRETIVAS_STATUS"] = "DeleteRangeAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["FILTER_ACOES_CORRETIVAS_STATUS"] = "FilterAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["GET_ACOES_CORRETIVAS_STATUS"] = "GetAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["GETWITHDISABLED_ACOES_CORRETIVAS_STATUS"] = "GetWithDisabledAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["GET_BY_ID_ACOES_CORRETIVAS_STATUS"] = "GetByIdAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["POST_ACOES_CORRETIVAS_STATUS"] = "PostAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["PUT_ACOES_CORRETIVAS_STATUS"] = "PutAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaAcoes_Corretivas_Status";
    Acoes_Corretivas_StatusActions["UPLOAD_PLANILHA"] = "UploadPlanilhaAcoes_Corretivas_Status";
})(Acoes_Corretivas_StatusActions || (Acoes_Corretivas_StatusActions = {}));
var AnomaliaActions;
(function (AnomaliaActions) {
    AnomaliaActions["DELETE_ANOMALIA"] = "DeleteAnomalia";
    AnomaliaActions["DELETE_RANGE_ANOMALIA"] = "DeleteRangeAnomalia";
    AnomaliaActions["FILTER_ANOMALIA"] = "FilterAnomalia";
    AnomaliaActions["GET_ANOMALIA"] = "GetAnomalia";
    AnomaliaActions["GETWITHDISABLED_ANOMALIA"] = "GetWithDisabledAnomalia";
    AnomaliaActions["GET_BY_ID_ANOMALIA"] = "GetByIdAnomalia";
    AnomaliaActions["POST_ANOMALIA"] = "PostAnomalia";
    AnomaliaActions["PUT_ANOMALIA"] = "PutAnomalia";
    AnomaliaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaAnomalia";
    AnomaliaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaAnomalia";
})(AnomaliaActions || (AnomaliaActions = {}));
var InspecaoActions;
(function (InspecaoActions) {
    InspecaoActions["DELETE_INSPECAO"] = "DeleteInspecao";
    InspecaoActions["DELETE_RANGE_INSPECAO"] = "DeleteRangeInspecao";
    InspecaoActions["FILTER_INSPECAO"] = "FilterInspecao";
    InspecaoActions["GET_INSPECAO"] = "GetInspecao";
    InspecaoActions["GETWITHDISABLED_INSPECAO"] = "GetWithDisabledInspecao";
    InspecaoActions["GET_BY_ID_INSPECAO"] = "GetByIdInspecao";
    InspecaoActions["POST_INSPECAO"] = "PostInspecao";
    InspecaoActions["PUT_INSPECAO"] = "PutInspecao";
    InspecaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaInspecao";
    InspecaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaInspecao";
})(InspecaoActions || (InspecaoActions = {}));
var Inspecao_Anomalia_StatusActions;
(function (Inspecao_Anomalia_StatusActions) {
    Inspecao_Anomalia_StatusActions["DELETE_INSPECAO_ANOMALIA_STATUS"] = "DeleteInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["DELETE_RANGE_INSPECAO_ANOMALIA_STATUS"] = "DeleteRangeInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["FILTER_INSPECAO_ANOMALIA_STATUS"] = "FilterInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["GET_INSPECAO_ANOMALIA_STATUS"] = "GetInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["GETWITHDISABLED_INSPECAO_ANOMALIA_STATUS"] = "GetWithDisabledInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["GET_BY_ID_INSPECAO_ANOMALIA_STATUS"] = "GetByIdInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["POST_INSPECAO_ANOMALIA_STATUS"] = "PostInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["PUT_INSPECAO_ANOMALIA_STATUS"] = "PutInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaInspecao_Anomalia_Status";
    Inspecao_Anomalia_StatusActions["UPLOAD_PLANILHA"] = "UploadPlanilhaInspecao_Anomalia_Status";
})(Inspecao_Anomalia_StatusActions || (Inspecao_Anomalia_StatusActions = {}));
var Inspecao_RespostaActions;
(function (Inspecao_RespostaActions) {
    Inspecao_RespostaActions["DELETE_INSPECAO_RESPOSTA"] = "DeleteInspecao_Resposta";
    Inspecao_RespostaActions["DELETE_RANGE_INSPECAO_RESPOSTA"] = "DeleteRangeInspecao_Resposta";
    Inspecao_RespostaActions["FILTER_INSPECAO_RESPOSTA"] = "FilterInspecao_Resposta";
    Inspecao_RespostaActions["GET_INSPECAO_RESPOSTA"] = "GetInspecao_Resposta";
    Inspecao_RespostaActions["GETWITHDISABLED_INSPECAO_RESPOSTA"] = "GetWithDisabledInspecao_Resposta";
    Inspecao_RespostaActions["GET_BY_ID_INSPECAO_RESPOSTA"] = "GetByIdInspecao_Resposta";
    Inspecao_RespostaActions["POST_INSPECAO_RESPOSTA"] = "PostInspecao_Resposta";
    Inspecao_RespostaActions["PUT_INSPECAO_RESPOSTA"] = "PutInspecao_Resposta";
    Inspecao_RespostaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaInspecao_Resposta";
    Inspecao_RespostaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaInspecao_Resposta";
})(Inspecao_RespostaActions || (Inspecao_RespostaActions = {}));
var Inspecao_Resposta_AnomaliaActions;
(function (Inspecao_Resposta_AnomaliaActions) {
    Inspecao_Resposta_AnomaliaActions["DELETE_INSPECAO_RESPOSTA_ANOMALIA"] = "DeleteInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["DELETE_RANGE_INSPECAO_RESPOSTA_ANOMALIA"] = "DeleteRangeInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["FILTER_INSPECAO_RESPOSTA_ANOMALIA"] = "FilterInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["GET_INSPECAO_RESPOSTA_ANOMALIA"] = "GetInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["GETWITHDISABLED_INSPECAO_RESPOSTA_ANOMALIA"] = "GetWithDisabledInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["GET_BY_ID_INSPECAO_RESPOSTA_ANOMALIA"] = "GetByIdInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["POST_INSPECAO_RESPOSTA_ANOMALIA"] = "PostInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["PUT_INSPECAO_RESPOSTA_ANOMALIA"] = "PutInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaInspecao_Resposta_Anomalia";
    Inspecao_Resposta_AnomaliaActions["UPLOAD_PLANILHA"] = "UploadPlanilhaInspecao_Resposta_Anomalia";
})(Inspecao_Resposta_AnomaliaActions || (Inspecao_Resposta_AnomaliaActions = {}));
var Inspecao_Resposta_FotosActions;
(function (Inspecao_Resposta_FotosActions) {
    Inspecao_Resposta_FotosActions["DELETE_INSPECAO_RESPOSTA_FOTOS"] = "DeleteInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["DELETE_RANGE_INSPECAO_RESPOSTA_FOTOS"] = "DeleteRangeInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["FILTER_INSPECAO_RESPOSTA_FOTOS"] = "FilterInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["GET_INSPECAO_RESPOSTA_FOTOS"] = "GetInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["GETWITHDISABLED_INSPECAO_RESPOSTA_FOTOS"] = "GetWithDisabledInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["GET_BY_ID_INSPECAO_RESPOSTA_FOTOS"] = "GetByIdInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["POST_INSPECAO_RESPOSTA_FOTOS"] = "PostInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["PUT_INSPECAO_RESPOSTA_FOTOS"] = "PutInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaInspecao_Resposta_Fotos";
    Inspecao_Resposta_FotosActions["UPLOAD_PLANILHA"] = "UploadPlanilhaInspecao_Resposta_Fotos";
})(Inspecao_Resposta_FotosActions || (Inspecao_Resposta_FotosActions = {}));
var Inspecao_StatusActions;
(function (Inspecao_StatusActions) {
    Inspecao_StatusActions["DELETE_INSPECAO_STATUS"] = "DeleteInspecao_Status";
    Inspecao_StatusActions["DELETE_RANGE_INSPECAO_STATUS"] = "DeleteRangeInspecao_Status";
    Inspecao_StatusActions["FILTER_INSPECAO_STATUS"] = "FilterInspecao_Status";
    Inspecao_StatusActions["GET_INSPECAO_STATUS"] = "GetInspecao_Status";
    Inspecao_StatusActions["GETWITHDISABLED_INSPECAO_STATUS"] = "GetWithDisabledInspecao_Status";
    Inspecao_StatusActions["GET_BY_ID_INSPECAO_STATUS"] = "GetByIdInspecao_Status";
    Inspecao_StatusActions["POST_INSPECAO_STATUS"] = "PostInspecao_Status";
    Inspecao_StatusActions["PUT_INSPECAO_STATUS"] = "PutInspecao_Status";
    Inspecao_StatusActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaInspecao_Status";
    Inspecao_StatusActions["UPLOAD_PLANILHA"] = "UploadPlanilhaInspecao_Status";
})(Inspecao_StatusActions || (Inspecao_StatusActions = {}));
var PrioridadeActions;
(function (PrioridadeActions) {
    PrioridadeActions["DELETE_PRIORIDADE"] = "DeletePrioridade";
    PrioridadeActions["DELETE_RANGE_PRIORIDADE"] = "DeleteRangePrioridade";
    PrioridadeActions["FILTER_PRIORIDADE"] = "FilterPrioridade";
    PrioridadeActions["GET_PRIORIDADE"] = "GetPrioridade";
    PrioridadeActions["GETWITHDISABLED_PRIORIDADE"] = "GetWithDisabledPrioridade";
    PrioridadeActions["GET_BY_ID_PRIORIDADE"] = "GetByIdPrioridade";
    PrioridadeActions["POST_PRIORIDADE"] = "PostPrioridade";
    PrioridadeActions["PUT_PRIORIDADE"] = "PutPrioridade";
    PrioridadeActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaPrioridade";
    PrioridadeActions["UPLOAD_PLANILHA"] = "UploadPlanilhaPrioridade";
})(PrioridadeActions || (PrioridadeActions = {}));
var QuestaoActions;
(function (QuestaoActions) {
    QuestaoActions["DELETE_QUESTAO"] = "DeleteQuestao";
    QuestaoActions["DELETE_RANGE_QUESTAO"] = "DeleteRangeQuestao";
    QuestaoActions["FILTER_QUESTAO"] = "FilterQuestao";
    QuestaoActions["GET_QUESTAO"] = "GetQuestao";
    QuestaoActions["GETWITHDISABLED_QUESTAO"] = "GetWithDisabledQuestao";
    QuestaoActions["GET_BY_ID_QUESTAO"] = "GetByIdQuestao";
    QuestaoActions["POST_QUESTAO"] = "PostQuestao";
    QuestaoActions["PUT_QUESTAO"] = "PutQuestao";
    QuestaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaQuestao";
    QuestaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaQuestao";
})(QuestaoActions || (QuestaoActions = {}));
var Questao_OpcaoActions;
(function (Questao_OpcaoActions) {
    Questao_OpcaoActions["DELETE_QUESTAO_OPCAO"] = "DeleteQuestao_Opcao";
    Questao_OpcaoActions["DELETE_RANGE_QUESTAO_OPCAO"] = "DeleteRangeQuestao_Opcao";
    Questao_OpcaoActions["FILTER_QUESTAO_OPCAO"] = "FilterQuestao_Opcao";
    Questao_OpcaoActions["GET_QUESTAO_OPCAO"] = "GetQuestao_Opcao";
    Questao_OpcaoActions["GETWITHDISABLED_QUESTAO_OPCAO"] = "GetWithDisabledQuestao_Opcao";
    Questao_OpcaoActions["GET_BY_ID_QUESTAO_OPCAO"] = "GetByIdQuestao_Opcao";
    Questao_OpcaoActions["POST_QUESTAO_OPCAO"] = "PostQuestao_Opcao";
    Questao_OpcaoActions["PUT_QUESTAO_OPCAO"] = "PutQuestao_Opcao";
    Questao_OpcaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaQuestao_Opcao";
    Questao_OpcaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaQuestao_Opcao";
})(Questao_OpcaoActions || (Questao_OpcaoActions = {}));
var RoteiroActions;
(function (RoteiroActions) {
    RoteiroActions["DELETE_ROTEIRO"] = "DeleteRoteiro";
    RoteiroActions["DELETE_RANGE_ROTEIRO"] = "DeleteRangeRoteiro";
    RoteiroActions["FILTER_ROTEIRO"] = "FilterRoteiro";
    RoteiroActions["GET_ROTEIRO"] = "GetRoteiro";
    RoteiroActions["GETWITHDISABLED_ROTEIRO"] = "GetWithDisabledRoteiro";
    RoteiroActions["GET_BY_ID_ROTEIRO"] = "GetByIdRoteiro";
    RoteiroActions["POST_ROTEIRO"] = "PostRoteiro";
    RoteiroActions["PUT_ROTEIRO"] = "PutRoteiro";
    RoteiroActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaRoteiro";
    RoteiroActions["UPLOAD_PLANILHA"] = "UploadPlanilhaRoteiro";
})(RoteiroActions || (RoteiroActions = {}));
var Roteiro_GrupoActions;
(function (Roteiro_GrupoActions) {
    Roteiro_GrupoActions["DELETE_ROTEIRO_GRUPO"] = "DeleteRoteiro_Grupo";
    Roteiro_GrupoActions["DELETE_RANGE_ROTEIRO_GRUPO"] = "DeleteRangeRoteiro_Grupo";
    Roteiro_GrupoActions["FILTER_ROTEIRO_GRUPO"] = "FilterRoteiro_Grupo";
    Roteiro_GrupoActions["GET_ROTEIRO_GRUPO"] = "GetRoteiro_Grupo";
    Roteiro_GrupoActions["GETWITHDISABLED_ROTEIRO_GRUPO"] = "GetWithDisabledRoteiro_Grupo";
    Roteiro_GrupoActions["GET_BY_ID_ROTEIRO_GRUPO"] = "GetByIdRoteiro_Grupo";
    Roteiro_GrupoActions["POST_ROTEIRO_GRUPO"] = "PostRoteiro_Grupo";
    Roteiro_GrupoActions["PUT_ROTEIRO_GRUPO"] = "PutRoteiro_Grupo";
    Roteiro_GrupoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaRoteiro_Grupo";
    Roteiro_GrupoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaRoteiro_Grupo";
})(Roteiro_GrupoActions || (Roteiro_GrupoActions = {}));
var Campo_Fluxo_InspecaoActions;
(function (Campo_Fluxo_InspecaoActions) {
    Campo_Fluxo_InspecaoActions["DELETE_CAMPO_FLUXO_INSPECAO"] = "DeleteCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["DELETE_RANGE_CAMPO_FLUXO_INSPECAO"] = "DeleteRangeCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["FILTER_CAMPO_FLUXO_INSPECAO"] = "FilterCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["GET_CAMPO_FLUXO_INSPECAO"] = "GetCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["GETWITHDISABLED_CAMPO_FLUXO_INSPECAO"] = "GetWithDisabledCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["GET_BY_ID_CAMPO_FLUXO_INSPECAO"] = "GetByIdCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["POST_CAMPO_FLUXO_INSPECAO"] = "PostCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["PUT_CAMPO_FLUXO_INSPECAO"] = "PutCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaCampo_Fluxo_Inspecao";
    Campo_Fluxo_InspecaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaCampo_Fluxo_Inspecao";
})(Campo_Fluxo_InspecaoActions || (Campo_Fluxo_InspecaoActions = {}));
var Campo_TipoActions;
(function (Campo_TipoActions) {
    Campo_TipoActions["DELETE_CAMPO_TIPO"] = "DeleteCampo_Tipo";
    Campo_TipoActions["DELETE_RANGE_CAMPO_TIPO"] = "DeleteRangeCampo_Tipo";
    Campo_TipoActions["FILTER_CAMPO_TIPO"] = "FilterCampo_Tipo";
    Campo_TipoActions["GET_CAMPO_TIPO"] = "GetCampo_Tipo";
    Campo_TipoActions["GETWITHDISABLED_CAMPO_TIPO"] = "GetWithDisabledCampo_Tipo";
    Campo_TipoActions["GET_BY_ID_CAMPO_TIPO"] = "GetByIdCampo_Tipo";
    Campo_TipoActions["POST_CAMPO_TIPO"] = "PostCampo_Tipo";
    Campo_TipoActions["PUT_CAMPO_TIPO"] = "PutCampo_Tipo";
    Campo_TipoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaCampo_Tipo";
    Campo_TipoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaCampo_Tipo";
})(Campo_TipoActions || (Campo_TipoActions = {}));
var Etapa_Fluxo_InspecaoActions;
(function (Etapa_Fluxo_InspecaoActions) {
    Etapa_Fluxo_InspecaoActions["DELETE_ETAPA_FLUXO_INSPECAO"] = "DeleteEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["DELETE_RANGE_ETAPA_FLUXO_INSPECAO"] = "DeleteRangeEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["FILTER_ETAPA_FLUXO_INSPECAO"] = "FilterEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["GET_ETAPA_FLUXO_INSPECAO"] = "GetEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["GETWITHDISABLED_ETAPA_FLUXO_INSPECAO"] = "GetWithDisabledEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["GET_BY_ID_ETAPA_FLUXO_INSPECAO"] = "GetByIdEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["POST_ETAPA_FLUXO_INSPECAO"] = "PostEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["PUT_ETAPA_FLUXO_INSPECAO"] = "PutEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaEtapa_Fluxo_Inspecao";
    Etapa_Fluxo_InspecaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaEtapa_Fluxo_Inspecao";
})(Etapa_Fluxo_InspecaoActions || (Etapa_Fluxo_InspecaoActions = {}));
var Fluxo_InspecaoActions;
(function (Fluxo_InspecaoActions) {
    Fluxo_InspecaoActions["DELETE_FLUXO_INSPECAO"] = "DeleteFluxo_Inspecao";
    Fluxo_InspecaoActions["DELETE_RANGE_FLUXO_INSPECAO"] = "DeleteRangeFluxo_Inspecao";
    Fluxo_InspecaoActions["FILTER_FLUXO_INSPECAO"] = "FilterFluxo_Inspecao";
    Fluxo_InspecaoActions["GET_FLUXO_INSPECAO"] = "GetFluxo_Inspecao";
    Fluxo_InspecaoActions["GETWITHDISABLED_FLUXO_INSPECAO"] = "GetWithDisabledFluxo_Inspecao";
    Fluxo_InspecaoActions["GET_BY_ID_FLUXO_INSPECAO"] = "GetByIdFluxo_Inspecao";
    Fluxo_InspecaoActions["POST_FLUXO_INSPECAO"] = "PostFluxo_Inspecao";
    Fluxo_InspecaoActions["PUT_FLUXO_INSPECAO"] = "PutFluxo_Inspecao";
    Fluxo_InspecaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaFluxo_Inspecao";
    Fluxo_InspecaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaFluxo_Inspecao";
})(Fluxo_InspecaoActions || (Fluxo_InspecaoActions = {}));
var Join_Fluxo_Inspecao_CampoActions;
(function (Join_Fluxo_Inspecao_CampoActions) {
    Join_Fluxo_Inspecao_CampoActions["DELETE_JOIN_FLUXO_INSPECAO_CAMPO"] = "DeleteJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["DELETE_RANGE_JOIN_FLUXO_INSPECAO_CAMPO"] = "DeleteRangeJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["FILTER_JOIN_FLUXO_INSPECAO_CAMPO"] = "FilterJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["GET_JOIN_FLUXO_INSPECAO_CAMPO"] = "GetJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["GETWITHDISABLED_JOIN_FLUXO_INSPECAO_CAMPO"] = "GetWithDisabledJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["GET_BY_ID_JOIN_FLUXO_INSPECAO_CAMPO"] = "GetByIdJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["POST_JOIN_FLUXO_INSPECAO_CAMPO"] = "PostJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["PUT_JOIN_FLUXO_INSPECAO_CAMPO"] = "PutJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaJoin_Fluxo_Inspecao_Campo";
    Join_Fluxo_Inspecao_CampoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaJoin_Fluxo_Inspecao_Campo";
})(Join_Fluxo_Inspecao_CampoActions || (Join_Fluxo_Inspecao_CampoActions = {}));
export { Acoes_CorretivasActions, Acoes_Corretivas_StatusActions, AnomaliaActions, InspecaoActions, Inspecao_Anomalia_StatusActions, Inspecao_RespostaActions, Inspecao_Resposta_AnomaliaActions, Inspecao_Resposta_FotosActions, Inspecao_StatusActions, PrioridadeActions, QuestaoActions, Questao_OpcaoActions, RoteiroActions, Roteiro_GrupoActions, Campo_Fluxo_InspecaoActions, Campo_TipoActions, Etapa_Fluxo_InspecaoActions, Fluxo_InspecaoActions, Join_Fluxo_Inspecao_CampoActions, };
//# sourceMappingURL=rotEnums.js.map